import React, { useState, useEffect } from "react";
import styles from "../Login/login.module.css";
import styles2 from "../UserDetails/userDetails.module.css";
// import Redefining from "../Resources/Redefine_Results.svg";
import { AiOutlineMail } from "react-icons/ai";
import axios from "axios";
import Logo from "../assets/logo-with-text.svg";
import BgAnimation from "../assets/bg-animation2.mp4";

const ForgotPassowrd = () => {
  const [email, setEmail] = useState("");
  const [showMsg, setShowMsg] = useState("");
  const [show, setShow] = useState(false);
  const [error, setError] = useState("");
  const [errorShow, setErrorShow] = useState(false);
  const [isLoading, setIsLoading] = useState(false);

  const handleSubmit = () => {
    if (!email) {
      setError("Please Enter the email");
    } else {
      setIsLoading(true);
      axios
        .post("https://server.anshfintech.com/send-mail", {
          email: email,
        })
        .then((res) => {
          setShow(true);
          setShowMsg("Email has been sent to your email");
        })
        .catch((err) => {
          setErrorShow(true);
          setError(err.response.data.msg);
        })
        .finally(() => {
          setIsLoading(false);
        });
    }
  };

  useEffect(() => {
    if (show) {
      setShow(true);
      const toRef = setTimeout(() => {
        setShow(false);
        setEmail("");
        clearTimeout(toRef);
      }, 4000);
    }
  }, [show]);

  useEffect(() => {
    if (errorShow) {
      setErrorShow(true);
      const toRef = setTimeout(() => {
        setErrorShow(false);
        setEmail("");
        clearTimeout(toRef);
      }, 4000);
    }
  }, [errorShow]);

  return (
    <div className={`relative flex flex-col items-center lg:space-y-0 lg:flex-row min-h-screen w-full lg:items-center justify-center px-6 md:px-10 lg:px-0`}>
      <div>
        <video 
          autoPlay 
          loop 
          muted 
          playsInline
          webkit-playsinline="true"
          className="absolute inset-0 w-full h-full object-cover z-0 backdrop-blur-md"
          poster={BgAnimation}
        >
          <source src={BgAnimation} type="video/mp4" />
          Your browser does not support the video tag.
        </video>
        <div className="absolute inset-0 w-full h-full bg-black opacity-20 z-0"></div>
      </div>
      <div className="relative z-10 w-full md:w-auto rounded-[12px] md:rounded-[26px] sshadow-custom-inner bg-gradient-to-br from-[#ffffff]/5 via-[#8BD89500] to-[#8BD89500] p-[1.5px]">
        <div className={` ${styles.loginBackground} w-full h-full flex flex-col p-[20px] md:p-[60px] rounded-[12px] md:rounded-[26px] shadow-custom-inner backdrop-blur-custom bg-transparent`}>
          <div className={`w-full flex items-center justify-center text-[24px] lg:text-[50px] lg:leading-[48px] font-bold font-poppins text-[#ffffff]  `}>
            <img src={Logo} alt="logo" className="w-[100px] md:w-[160px] lg:w-[220px]" />
          </div>
          <div className={`text-center text-[20px] mt-5 lg:text-[28px] lg:leading-[24px] font-medium lg:mt-[30px] text-[#ffffff]`}>
            Forgot your Password?
          </div>
          <div className={`text-center text-[11px] mt-2 lg:text-[14px] lg:leading-[32px] font-normal lg:mt-[6px] text-[#ffffffcc]`}>
            Don't worry. We'll send you an email to reset your password.
          </div>
          <div className={`flex items-center mt-[40px] bg-[#ffffff0a] rounded-[6px]`}>
            <AiOutlineMail className={`ml-4 w-5 h-5  text-[#FFCF2C]`} />
            <input
              type="text"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              placeholder="Email"
              className={styles.logininput}
            />
          </div>
          {errorShow === true ? (
            <div className={styles.errorMsg}>{error}</div>
          ) : null}
          {show === true ? (
            <div className={styles2.successMsg}>{showMsg}</div>
          ) : null}
          <button 
            className={`${styles.loginButton} relative`} 
            onClick={handleSubmit}
            disabled={isLoading}
          >
            {isLoading ? (
              <div className="flex items-center justify-center">
                <div className="w-6 h-6 border-2 border-white border-t-transparent rounded-full animate-spin"></div>
              </div>
            ) : (
              "Reset Password"
            )}
          </button>
        </div>
      </div>
    </div>
  );
};

export default ForgotPassowrd;
